const supportedProviders = ["ttlock", "schlage"];

const supportsProvider = (hotel, door = hotel) => {
  const provider = door?.lockType || hotel?.lockType || "ttlock";
  if (provider === "oracode") return false;
  const capabilities =
    door?.capabilities ||
    (provider === (hotel?.lockType || "ttlock")
      ? hotel?.capabilities
      : undefined);
  return capabilities?.masterPasscodes ?? supportedProviders.includes(provider);
};

export const supportsMasterCodes = (hotel, doors = []) =>
  hotel?.serviceType !== "messaging" &&
  (supportsProvider(hotel) ||
    Object.entries(hotel?.lockAdmins || {}).some(
      ([provider, account]) =>
        account &&
        provider !== hotel?.lockType &&
        supportedProviders.includes(provider),
    ) ||
    doors.some((door) => supportsProvider(hotel, door)));

export const isMasterCodeDoor = (hotel, door) =>
  !!door.lockId && !door.disabled && supportsProvider(hotel, door);

export const isPendingMasterCode = (access) =>
  access.status === "pending" || !!access.pendingOperation;

export const masterCodeResults = (response) =>
  (response?.results || []).flatMap((result) =>
    result.results ? masterCodeResults(result) : [result],
  );
